import { DatePipe } from '@angular/common';
import { Component,ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestQuoteListService } from 'src/app/services/request-quote-list.service';
import { KnBrPhoneHelper } from 'src/app/shared/helpers/kn-br-phone-helpers';
import { Router } from '@angular/router';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { KnBrSalesCheckoutService } from 'src/app/services/kn-br-sales-checkout.service';
import { MediaComponent } from '@spartacus/storefront';

@Component({
  selector: 'knbr-kn-br-request-quote-listing-details',
  imports: [MediaComponent],
  templateUrl: './kn-br-request-quote-listing-details.component.html',
  styleUrl: './kn-br-request-quote-listing-details.component.scss',
  providers: [DatePipe],
})
export class KnBrRequestQuoteListingDetailsComponent {
  orderConfirmationData: any;
  quoteId = '';
  isLoading = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private requestQuoteListService: RequestQuoteListService,
    private knBrPhoneHelper: KnBrPhoneHelper,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private commonService: KnBrCommonService,
    private checkoutService: KnBrSalesCheckoutService
  ) {}

  ngOnInit(): void {
    this.quoteId = this.getQuoteIdFromRoute();
    if (!this.quoteId) {
      this.isLoading = false;
      return;
    }

    this.commonService.showSpinner$.next(true);
    this.requestQuoteListService.getRequestQuoteDetails(this.quoteId).subscribe((response) => {
      this.orderConfirmationData = response;
      console.log('RQ details image payload:', this.orderConfirmationData?.entries?.[0]?.product?.images);
      this.isLoading = false;
      this.commonService.showSpinner$.next(false);
      this.cdr.detectChanges();
    }, () => {
      this.isLoading = false;
      this.commonService.showSpinner$.next(false);
    });
  }

  private getQuoteIdFromRoute(): string {
    const routeParams = this.route.snapshot.paramMap;
    const quoteIdFromParams = routeParams.get('orderId') || routeParams.get('quoteId') || routeParams.get('id');

    if (quoteIdFromParams) {
      return quoteIdFromParams;
    }

    const cleanUrl = (this.router.url || '').split('?')[0];
    const quoteIdFromPath = cleanUrl.split('/quoteRequestDetails/')[1]?.split('/')[0];

    if (quoteIdFromPath) {
      return quoteIdFromPath;
    }

    const segments = this.route.snapshot.url;
    return segments.length ? segments[segments.length - 1].path : '';
  }

  getFormattedPhone(): string {
    const phone = this.orderConfirmationData?.deliveryAddress?.phone;
    if (!phone) {
      return '-';
    }
    return this.knBrPhoneHelper.formatPhoneNumber(phone);
  }

  formatDisplayDate(value: string | Date): string {
    if (!value) {
      return '';
    }
    return this.datePipe.transform(value, 'MMMM d, y') || String(value);
  }

  calculateTotalPrice(unitPrice: number, quantity: number): string {
    const total = (unitPrice || 0) * (quantity || 0);
    return total.toFixed(2);
  }


  getShipmentNotes(): string {
    return this.orderConfirmationData?.deliveryAddress?.note || this.orderConfirmationData?.requestQuoteNotes || 'No';
  }

  getUploadedFiles(): any[] {
    const files =
      this.orderConfirmationData?.uploadedFiles ||
      this.orderConfirmationData?.files ||
      this.orderConfirmationData?.attachments ||
      this.orderConfirmationData?.fileReferenceId ||
      this.orderConfirmationData?.deliveryAddress?.uploadedFiles ||
      this.orderConfirmationData?.deliveryAddress?.files ||
      [];

    return Array.isArray(files) ? files : [];
  }

  backToQuoteHistory(): void {
    this.router.navigateByUrl('/quoteRequests');
  }

  resolveImageUrl(item: any): string {
    return this.checkoutService.resolveImageUrl(item);
  }
}
